<template>
  <span class="ai-badge">
    <i class="fa-solid fa-wand-magic-sparkles"></i>
    {{ $t('Generado con IA') }}
  </span>
</template>

<script>
export default {
  name: "AIBadge"
}
</script>

<style scoped>
.ai-badge {
  background: linear-gradient(135deg, #6366f1 0%, #a855f7 100%);
  color: white;
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 10px rgba(99, 102, 241, 0.2);
  width: fit-content;
}
</style>
